import {User, USER_ROLES} from '../interfaces/user.interface';

export function isUserNurse({role}: Pick<User, 'role'>): boolean {
  return role === USER_ROLES.NURSE;
}
